import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";

export interface BorcluGsmTalep {
    dosyaId: string,
    kisiKurumId: number,
    dosyaHash?: string
}

export interface BorcluGsmCevap extends ISorguSonuc<BorcluGsmCevapItem> {}

export interface BorcluGsmCevapItem {
    adres: string,
    operator?: string
}

// Güncellenme Tarihi: 21/01/2026

export default class BorcluGsm extends UyapRequest<BorcluGsmTalep, BorcluGsmCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Borçlu GSM bilgileri sorgulanıyor...";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "borcluGsm_" + app.$uyapHelper.hashTalepForCache(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"2********96","adi":"MU***** SE****","soyadi":"KA******","babaAdi":"M*****","anaAdi":"F******","dogumTarihiStr":"1965","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":38765885,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 0. Genel İcra Dairesi","birimId":"100096","orgKodu":"1.04.011.000.603","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2020/2700000","dosyaNoYil":2020,"dosyaSira":270000,"dosyaId":"HMx85JbgLks4CT0eDU","dosyaAcilisTarihi":"28/12/2023 23:25","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"Hğğğ Tğğğ, Müüü Süüü Küüü","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"21/01/2026 11:30","sorguSonucDVO":[{"adres":"Fener MH. Fethi Paşa Blv. CD No:70 D:35 Bahçelievler, İstanbul","operator":"Turkcell"},{"adres":"Mimar Sinan MH. Millet Caddesi CD No:67 D:42 Güngören, İstanbul","operator":"Vodafone"},{"adres":"Beyoğlu MH. İstiklal Caddesi 22-24 D:11 Beyoğlu, İstanbul","operator":""},{"adres":"Fatih MH. Edirnekapı Cd. CD No:125 D:67 Fatih, İstanbul","operator":"Turkcell"},{"adres":"Kavaklıdere MH. Atatürk Caddesi CD No:56 D:32 Beyoğlu, Ankara","operator":"Vodafone"}],"sorgulamaTuru":"GSM","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_gsm.ajx';
    }

    async parse(data: any): Promise<BorcluGsmCevap> {
        data.message = `Kişiye ait GSM operatörlerinde kaydı ${data.sorguSonucDVO?.lenght>0? "var" : "yok"}`;
        return data;
    }
}